import script from "./web-knowledge-detail.vue?vue&type=script&setup=true&lang=js"
export * from "./web-knowledge-detail.vue?vue&type=script&setup=true&lang=js"

import "./web-knowledge-detail.vue?vue&type=style&index=0&id=3fafcfc2&lang=scss"

const __exports__ = script;

export default __exports__